<template>
  <div class="share-money background-gradient">
    <div class="header">
      <div class="back" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <h1>{{ $t('Share & Earn') }}</h1>
      <div class="header-right"></div>
    </div>

    <div class="content">
      <!-- 未成为代理：介绍页，不自动跳转 -->
      <div v-if="!isAgent" class="guest-wrap">
        <div class="hero-card">
          <div class="hero-badge">{{ $t('Agent Program') }}</div>
          <h2 class="hero-title">{{ statusTitle }}</h2>
          <p class="hero-desc">{{ statusText }}</p>
          <div class="rate-row" v-if="rates.l1 || rates.l2 || rates.l3">
            <div class="rate-item">
              <span class="rate-num">{{ rates.l1 }}%</span>
              <span class="rate-label">{{ $t('Direct Level') }}</span>
            </div>
            <div class="rate-item">
              <span class="rate-num">{{ rates.l2 }}%</span>
              <span class="rate-label">{{ $t('Second Level') }}</span>
            </div>
            <div class="rate-item">
              <span class="rate-num">{{ rates.l3 }}%</span>
              <span class="rate-label">{{ $t('Third Level') }}</span>
            </div>
          </div>
          <div class="action-row">
            <button
              v-if="applyStatus !== 'pending'"
              class="primary-btn"
              @click="$router.push('/applyagent')"
            >
              {{ applyStatus === 'refused' ? $t('Re-apply') : $t('Become Agent') }}
            </button>
            <button class="ghost-btn" @click="openKefu">
              {{ $t('Contact Customer Service') }}
            </button>
          </div>
        </div>

        <div class="rules-card">
          <div class="rules-title">{{ $t('Agent Rules') }}</div>
          <div class="rules-body" v-html="ruleHtml"></div>
        </div>
      </div>

      <!-- 已是代理：邀请链接 -->
      <div class="promotion-section" v-else>
        <div class="invite-container">
          <div class="invite-header-row">
            <div class="invite-header">
              <h3>{{ $t('Invite Link') }}</h3>
            </div>
            <div class="invite-stats">
              <div class="invite-stat-item">
                <span class="stat-label">{{ $t('Direct Invites') }}</span>
                <span class="stat-value">{{ stats.directAgents || 0 }} {{ $t('people') }}</span>
              </div>
            </div>
          </div>

          <div class="invite-link-box">
            <input type="text" :value="normalLink" readonly class="invite-link-input">
            <button class="copy-btn" @click="copyLink('normal')">
              {{ $t('Copy') }}
            </button>
          </div>

          <div class="invite-qr-code">
            <div class="qr-code-wrapper">
              <img :src="qrCodeUrl" alt="QR Code" class="qr-code-image" ref="qrCodeImage">
            </div>
            <button class="save-qr-btn" @click="saveQRCode">{{ $t('Save to Album') }}</button>
          </div>
        </div>

        <div class="rules-card agent-rules">
          <div class="rules-title">{{ $t('Agent Rules') }}</div>
          <div class="rules-body" v-html="ruleHtml"></div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Foot from './libs/Foot';

export default {
  name: 'shareMoney',
  components: {
    Foot
  },
  data() {
    return {
      normalLink: '',
      wechatLink: '',
      rebateData: {
        daily: 0,
        weekly: 0,
        monthly: 0
      },
      inviteCode: '',
      qrCodeUrl: '',
      isAgent: false,
      applyStatus: 'none',
      ruleHtml: '',
      rates: { l1: 20, l2: 3, l3: 2 },
      stats: {
        totalMembers: 0,
        totalAgents: 0,
        directMembers: 0,
        directAgents: 0
      }
    };
  },
  computed: {
    statusTitle() {
      if (this.applyStatus === 'pending') return this.$t('Agent Pending Review');
      if (this.applyStatus === 'refused') return this.$t('Agent Application Refused');
      return this.$t('Become Agent');
    },
    statusText() {
      if (this.applyStatus === 'pending') return this.$t('Please wait for review');
      if (this.applyStatus === 'refused') return this.$t('Agent Application Refused');
      return this.$t('Apply to become agent first');
    }
  },
  created() {
    this.getShareInfo();
    this.getTeamStats();
  },
  methods: {
    openKefu() {
      if (this.$parent && this.$parent.openKefu) {
        this.$parent.openKefu();
        return;
      }
      this.$router.push('/kefu');
    },
    getShareInfo() {
      const lang = (this.$i18n && this.$i18n.locale) || 'zh';
      this.$apiFun.get('/api/share/info', { lang }).then(res => {
        if (res.code === 200 && res.data) {
          this.isAgent = Number(res.data.is_agent) === 1;
          this.applyStatus = res.data.apply_status || 'none';
          this.ruleHtml = res.data.rule_html || '';
          if (res.data.rates) {
            this.rates = {
              l1: res.data.rates[1] != null ? res.data.rates[1] : (res.data.rates.l1 || 20),
              l2: res.data.rates[2] != null ? res.data.rates[2] : (res.data.rates.l2 || 3),
              l3: res.data.rates[3] != null ? res.data.rates[3] : (res.data.rates.l3 || 2)
            };
          }
          if (this.isAgent) {
            this.normalLink = res.data.normalLink || '';
            this.wechatLink = res.data.wechatLink || '';
            this.rebateData = res.data.rebateData || this.rebateData;
            this.inviteCode = res.data.inviteCode || '';
            this.qrCodeUrl = res.data.qrCodeUrl || this.generateQrCodeUrl();
          } else {
            this.normalLink = '';
            this.wechatLink = '';
            this.inviteCode = '';
            this.qrCodeUrl = '';
          }
        }
      }).catch(() => {});
    },
    generateQrCodeUrl() {
      const encodedUrl = encodeURIComponent(this.normalLink);
      return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodedUrl}`;
    },
    saveQRCode() {
      const img = this.$refs.qrCodeImage;
      if (!img) {
        alert(this.$t('QR code image does not exist'));
        return;
      }
      const canvas = document.createElement('canvas');
      canvas.width = 300;
      canvas.height = 300;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        ctx.drawImage(image, 10, 10, 280, 280);
        canvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'qrcode.png';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          alert(this.$t('QR code saved to album'));
        });
      };
      image.onerror = () => {
        alert(this.$t('Failed to save QR code, please try again'));
      };
      image.src = img.src;
    },
    getTeamStats() {
      if (!this.isAgent) return;
      this.$apiFun.get('/api/team/performance').then(res => {
        if (res.code === 200 && res.data) {
          this.stats = {
            totalMembers: res.data.totalMembers || 0,
            totalAgents: res.data.totalAgents || 0,
            directMembers: res.data.directMembers || 0,
            directAgents: res.data.directAgents || 0
          };
        }
      }).catch(() => {});
    },
    copyLink() {
      const link = this.normalLink;
      if (!link) return;
      const input = document.createElement('input');
      input.value = link;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert(this.$t('Link copied'));
    }
  }
};
</script>

<style lang="scss" scoped>
.background-gradient {
  background: linear-gradient(180deg, #fff8ef 0%, #ffffff 42%, #f7f2ea 100%);
  min-height: 100vh;
  box-sizing: border-box;
  color: #352b24;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(117, 73, 34, 0.18);
  color: #4a2e00;

  .back, .header-right {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h1 {
    flex: 1;
    text-align: center;
    font-size: 17px;
    margin: 0;
    font-weight: 700;
  }
}

.content {
  padding: 66px 16px calc(92px + env(safe-area-inset-bottom));
}

.guest-wrap {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.hero-card,
.rules-card,
.invite-container {
  background: #ffffff;
  border: 1px solid #eadfd3;
  border-radius: 18px;
  padding: 18px 16px;
  box-shadow: 0 8px 24px rgba(117, 73, 34, 0.08);
}

.hero-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(209, 160, 62, 0.15);
  color: #8f501f;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 10px;
}

.hero-title {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 800;
  color: #3a2718;
}

.hero-desc {
  margin: 0;
  color: #8a6a4a;
  font-size: 13px;
  line-height: 1.6;
}

.rate-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin: 16px 0 18px;
}

.rate-item {
  background: #fff8ef;
  border: 1px solid #ead1b2;
  border-radius: 12px;
  padding: 12px 6px;
  text-align: center;
}

.rate-num {
  display: block;
  font-size: 18px;
  font-weight: 800;
  color: #b8860b;
}

.rate-label {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: #8a6a4a;
}

.action-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.primary-btn,
.ghost-btn,
.copy-btn,
.save-qr-btn {
  height: 46px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
}

.primary-btn,
.copy-btn,
.save-qr-btn {
  border: none;
  background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
  color: #4a2e00;
}

.ghost-btn {
  background: #ffffff;
  border: 1px solid #d9c3a4;
  color: #8f501f;
}

.rules-title {
  font-size: 15px;
  font-weight: 800;
  margin-bottom: 10px;
  color: #4a2e00;
}

.rules-body {
  color: #5c4634;
  font-size: 13px;
  line-height: 1.7;
  word-break: break-word;

  ::v-deep p {
    margin: 0 0 8px;
  }

  ::v-deep ul,
  ::v-deep ol {
    margin: 0 0 8px;
    padding-left: 18px;
  }

  ::v-deep li {
    margin-bottom: 4px;
  }

  ::v-deep strong {
    color: #3a2718;
  }
}

.agent-rules {
  margin-top: 14px;
}

.invite-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.invite-header h3 {
  margin: 0;
  font-size: 16px;
}

.invite-stat-item {
  text-align: right;
  font-size: 12px;
  color: #8a6a4a;

  .stat-value {
    display: block;
    margin-top: 2px;
    font-size: 16px;
    font-weight: 800;
    color: #8f501f;
  }
}

.invite-link-box {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;

  .invite-link-input {
    flex: 1;
    height: 42px;
    border: 1px solid #ead1b2;
    border-radius: 8px;
    padding: 0 10px;
    background: #fff8ef;
    color: #352b24;
  }

  .copy-btn {
    padding: 0 14px;
    white-space: nowrap;
  }
}

.invite-qr-code {
  text-align: center;

  .qr-code-image {
    width: 150px;
    height: 150px;
    background: #fff;
    border: 1px solid #eadfd3;
    border-radius: 12px;
    padding: 8px;
  }

  .save-qr-btn {
    width: 100%;
    margin-top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shareMoney.vue